<template>
  <confirm-dialog
    ref="dialog"
    v-model="bookmarkDialog"
    icon="mdi-bookmark"
    title="バインダー"
    confirm-label="バインダーに登録する"
    message="この内容でバインダーに登録します"
    :disabled="selectedBinderToBookmark === null || descriptionValidator(bookmarkDescription) !== true"
    @confirm="bookmarkCommitHandler"
  >
    <v-select
      v-model="selectedBinderToBookmark"
      :items="binders"
      label="登録先バインダーを選択してください"
      item-color="primary"
      item-text="name"
      item-value="id"
    />
    <div class="webview-dialog-body">
      <p>
        文献名 {{ record.title }}<br />
        {{ headingText }}
      </p>
    </div>
    <v-textarea v-model="bookmarkDescription" label="メモ" outlined :rules="[descriptionValidator]" />
  </confirm-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import ConfirmDialog from '@/components/common/confirm-dialog.vue';
import { descriptionValidator } from '@/utils/binderFoldersUtils';
import { getTocByKey } from '@/utils/webViewerUtils';
import { Binder, Bookmark, DocRecord } from 'wklr-backend-sdk/models';

@Component({
  components: { ConfirmDialog },
})
export default class AddSectionBookmarkDialog extends Vue {
  $refs!: {
    dialog: ConfirmDialog;
  };

  descriptionValidator = descriptionValidator;

  @Prop()
  record!: DocRecord;

  @Prop()
  success?: (response: Bookmark, selectedBinder: Binder) => void;

  selectedSectionKey: number | null = null;
  get bookmarkDialog(): boolean {
    return this.selectedSectionKey !== null;
  }
  set bookmarkDialog(value) {
    if (!value) {
      this.selectedSectionKey = null;
    } else {
      console.warn('set selectedSectionKey to activate bookmarkDialog');
    }
  }

  get headingText(): string {
    if (this.selectedSectionKey) {
      const toc = getTocByKey(this.selectedSectionKey, this.record.toc);
      if (toc !== undefined) {
        return toc.label;
      }
    }

    return '';
  }

  binders: Binder[] = [];
  selectedBinderToBookmark: string | null = null;
  bookmarkDescription = '';

  get selectedBinder(): Binder | null {
    if (this.selectedBinderToBookmark === null) {
      return null;
    }
    return this.binders.find((b) => b.id === this.selectedBinderToBookmark) || null;
  }

  async bookmarkCommitHandler() {
    if (this.selectedSectionKey === null || this.selectedBinder === null) {
      this.bookmarkDialog = false;
      return;
    }

    try {
      const docDataUpdatedAt =
        this.record.publishedOn == null ? null : new Date(this.record.publishedOn).getTime() / 1000;
      const response = await this.$repositories.binderFolders.addSectionBookmarkToBinder(
        this.selectedBinder.id,
        this.record.id,
        this.bookmarkDescription,
        docDataUpdatedAt,
        this.selectedSectionKey,
        this.headingText,
      );
      this.$toast.success('バインダーに登録しました');
      this.bookmarkDialog = false;
      if (this.success) {
        this.success(response, this.selectedBinder);
      }
    } catch (error) {
      this.$refs.dialog.reactivate();
      console.error(error);
      this.$toast.error('バインダーへの登録に失敗しました');
    }
  }

  async show(sectionKey: number) {
    if (!(this.record.toc && this.record.toc.byKey[sectionKey])) {
      console.error(
        `存在しない見出しをバインダーに登録しようとしました。docId=${this.record.id}, sectionKey=${sectionKey}`,
      );
      this.$toast.error('バインダーへの登録に失敗しました');
      return;
    }

    const promise = this.$repositories.binderFolders.getAllBinders(false).then((binders) => {
      this.binders = binders;
    });

    this.selectedSectionKey = sectionKey;
    this.selectedBinderToBookmark = null;
    this.bookmarkDescription = '';
    await promise;
  }
}
</script>
